import { useQuery, QueryResult } from '@eika-infrastruktur/react-query';

import type { BankValidation, BicCode, CountryCode, Iban, NationalId } from '../generated-types';
import { validateBank, validateIban } from '../services/banksService';

export const useValidateBank = (
    bic?: BicCode,
    nationalId?: NationalId,
    countryCode?: CountryCode,
    isBban?: boolean,
    successCallback?: (data: BankValidation) => void,
    enable = true,
): QueryResult<BankValidation> => {
    return useQuery<BankValidation>({
        queryKey: ['bank-validation', bic, nationalId, countryCode],
        queryFn: () => validateBank(bic, nationalId, countryCode),
        enabled: isBban && enable,
        staleTime: Infinity,
        onSuccess: successCallback,
    });
};

export const useValidateIban = (
    iban?: Iban,
    enabled?: boolean,
    successCallback?: (data: BankValidation) => void,
): QueryResult<BankValidation> => {
    return useQuery<BankValidation>({
        queryKey: ['iban-validation', iban],
        queryFn: () => validateIban(iban!),
        enabled: !!iban && enabled,
        staleTime: Infinity,
        onSuccess: successCallback,
    });
};
